module.exports = __webpack_public_path__ + "static/trash.f47aa9295c1bff0d7226d285a895c466.svg";